<script setup>
import { computed, defineProps, defineEmits } from 'vue';

const emit = defineEmits(['update:checked']);

const props = defineProps({
    checked: Boolean,
    value: {
        type: null,
        required: false
    },
    dataTestId: {
      type: String,
      default: ''
  }
});

const proxyChecked = computed({
    get() {
        return props.checked;
    },

    set(val) {
        emit('update:checked', val);
    },
});
</script>

<template>
  <input
    v-model="proxyChecked"
    type="checkbox"
    :value="value"
    class="checkbox"
    :data-testid="dataTestId"
  >
</template>

<style scoped lang="postcss">
.checkbox {
  @apply appearance-none w-5 h-5 align-middle transition-colors duration-200 border-2 border-echoes-primary rounded-md cursor-pointer;
}

.checkbox:checked {
  @apply bg-echoes-primary relative;
}

.checkbox:checked::after {
  content: '';
  @apply absolute w-[5px] h-[10px] border-r-2 border-b-2 border-white;
  @apply rotate-45;
  left: 6px;
  top: 2px;
}

.checkbox:focus {
  @apply outline-none;
}
</style>
